module.exports = __webpack_public_path__ + "static/media/ritsu_top1e3023856e11a9ef89fe4f0aef0365cb.webp";